/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/assignments.js';
import {FormattedDate}  from 'react-intl';
import React  from 'react';
import Student from '../classes/student.js';

const getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

class ProductStore extends BaseStore {

    constructor() {
        super();

        if(getParameterByName("product"))
        {
            sessionStorage.setItem("product" , getParameterByName("product"));
        }

        this.product = sessionStorage.getItem("product") ? sessionStorage.getItem("product") : "languagenut";
    }

    productLocale(){

        switch(this.product)
        {
            case "pratstart": return 'sv';
            case 'huber':
            case 'hueber':
                return 'de';
            default:
                return false;
        }

    }

    getLogo(){
        return "img/logos/"+this.product+"/200px.png";
    }

}

export default new ProductStore();


// WEBPACK FOOTER //
// ./src/store/product-store.js